import { BRAND, LOGO, LOGO_WHITE } from "@/data/site";

export const Logo = ({ light = false, className = "h-12 sm:h-14" }) => (
  <a href="#top" className="group inline-flex items-center" data-testid="logo-link" aria-label={BRAND}>
    <img
      src={light ? LOGO_WHITE : LOGO}
      alt={`${BRAND} logo – Kendinin En Güzel Hâli`}
      className={`${className} w-auto object-contain transition-transform duration-500 group-hover:scale-[1.04]`}
      draggable="false"
    />
  </a>
);
